// extracted by mini-css-extract-plugin
module.exports = {"hrName":"ConsultationTable_hrName_3HMFT","actions":"ConsultationTable_actions_1MBcQ","emptyListPlug":"ConsultationTable_emptyListPlug_249MC"};